  import React, { useEffect, memo } from "react"
import AOS from "aos"
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion"
import parse from "html-react-parser"
import "aos/dist/aos.css"
import SectionsTitle from "../../Common/SectionsTitle"
import * as style from "./faq.module.css"

const BlogFaq = ({
  CustomClass,
  faqShowSection,
  faqQuestionAnswerList,
  faqSubTitle,
  // faqContent,
  // faqTitle,
}) => {
  useEffect(() => {
    AOS.init({
      once: true,
    })
  }, [])
  return (
    <>
      {faqShowSection === "yes" && (
        <section className={`${style.blogfaq} ${CustomClass}`}>
          <div className={style.faq_wrap}>
            <SectionsTitle
              title=""
              SubTitle={parse(`${faqSubTitle}`)}
              Content=""
              styleCss={{ display: "none" }}
              classnames="blogSection"
            />
            <div
              className={style.accordion_wrap}
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <Accordion
                className={style.accordion}
                allowMultipleExpanded={false}
                allowZeroExpanded={true}
              >
                {faqQuestionAnswerList?.map((item, index) => {
                  return (
                    <AccordionItem className={style.accordion_item} key={index}>
                      <AccordionItemHeading>
                        <AccordionItemButton className={style.accordion_button}>
                          <div className={style.faqTitle}>
                            {item?.faqListQuestion}
                          </div>
                          <i className={style.iconFAQ}></i>
                        </AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel className={style.accordion_panel}>
                        <p>{parse(`${item?.faqListAnswer}`)}</p>
                      </AccordionItemPanel>
                    </AccordionItem>
                  )
                })}
              </Accordion>
            </div>
          </div>
        </section>
      )}
    </>
  )
}

export default memo(BlogFaq)
